import request from '@/utils/request'

/**
 * 查询职务列表
 * @param query
 */
export function fetchList(query) {
	return request({
		url: '/api/job/list',
		method: 'post',
		data: query
	})
}

/**
 * 新增职务
 * @param param
 */
export function save(param) {
	return request({
		url: '/api/job/save',
		method: 'post',
		data: param
	})
}

/**
 * 修改职务
 * @param param
 */
export function update(param) {
	return request({
		url: '/api/job/update',
		method: 'post',
		data: param
	})
}

/**
 * 删除职务
 * @param param
 */
export function remove(param) {
	return request({
		url: '/api/job/delete/' + param,
		method: 'post'
	})
}

/**
 * 获取单个职务信息
 * @param param
 */
export function get(param) {
	return request({
		url: '/api/job/view/' + param,
		method: 'get'
	})
}
